import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

const SignatureCapture = ({ orderId, onSave, setIsSignatureModalOpen }) => {
  const sigPad = useRef({});
  const [receiverName, setReceiverName] = useState("");

  const clear = () => {
    sigPad.current.clear();
    setReceiverName("");
  };

  const save = () => {
    if (sigPad.current.isEmpty()) {
      alert("Пожалуйста, поставьте подпись перед сохранением.");
      return;
    }

    const dataURL = sigPad.current.toDataURL("image/png");
    onSave({ signature: dataURL, name: receiverName }); // Передаем объект с подписью и именем
    setIsSignatureModalOpen(false)
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60]"
      onClick={() => setIsSignatureModalOpen(false)}
    >
      <div
        className="bg-white p-6 rounded-xl shadow-2xl max-w-2xl w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Signature</h3>
          <button
            onClick={() => setIsSignatureModalOpen(false)}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            &times;
          </button>
        </div>
        <div
          style={{
            maxWidth: "600px",
            margin: "10px auto",
            textAlign: "center",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <h4>Signature for order № {orderId}</h4>
          <div style={{ marginBottom: "15px" }}>
            <input
              type="text"
              placeholder="Name or Passport number"
              value={receiverName}
              onChange={(e) => setReceiverName(e.target.value)}
              style={{
                padding: "8px",
                width: "100%",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "16px",
              }}
            />
          </div>
          <div
            style={{
              border: "2px solid #333",
              borderRadius: "8px",
              background: "#fff",
            }}
          >
            <SignatureCanvas
              ref={sigPad}
              penColor="black"
              canvasProps={{
                width: 600,
                height: 300,
                className: "sigCanvas",
                style: { width: "100%", height: "auto" }, // Адаптивность под телефон
              }}
            />
          </div>

          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <button onClick={clear} style={styles.clearBtn}>
              Clear
            </button>
            <button onClick={save} style={styles.saveBtn}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  clearBtn: {
    padding: "10px",
    backgroundColor: "#f44336",
    color: "white",
    border: "none",
    borderRadius: "4px",
  },
  saveBtn: {
    padding: "10px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
  },
};

export default SignatureCapture;
